module.exports = __webpack_public_path__ + "img/gengduo.eeca85f6.svg";